<login (onProfileClicked)="showProfilePage()"></login>

<div class="container body-content">
    <shared-header [appLocation]="thisRoute">
        <a class="btn btn-default dark-mode-toggle-global" (click)="toggleDarkMode()" [title]="isDarkMode ? 'Day mode' : 'Night mode'">
            <span [ngClass]="isDarkMode ? 'fas fa-sun' : 'fas fa-moon'"></span>
        </a>
        <div *ngIf="userHasAccessToConfiguration">
            <div [ngSwitch]="thisRoute">

                <div *ngSwitchCase="'/home'">
                    <h3>Configure</h3>
                    <a (click)="this.router.navigateByUrl('/settings/job-definition')">Job definitions</a>
                    <a (click)="this.router.navigateByUrl('/settings/mapper-config')">Mapper configuration</a>
                    <div *ngIf="showDeveloperOptions">
                        <a (click)="this.router.navigateByUrl('/settings/developer-options')">Developer options</a>
                    </div>
                    <process-home-config></process-home-config>
                </div>

                <div *ngSwitchCase="'/process/running'">
                    <h3>Configure</h3>
                    <a (click)="this.router.navigateByUrl('/settings/job-definition')">Job definitions</a>
                    <a (click)="this.router.navigateByUrl('/settings/mapper-config')">Mapper configuration</a>
                    <div *ngIf="showDeveloperOptions">
                        <a (click)="this.router.navigateByUrl('/settings/developer-options')">Developer options</a>
                    </div>
                </div>

                <div *ngSwitchCase="'/process/summary'">
                    <h3>Configure</h3>
                    <a>Dashboard settings</a>
                    <a (click)="this.router.navigateByUrl('/settings/job-definition')">Job definitions</a>
                    <a (click)="this.router.navigateByUrl('/settings/mapper-config')">Mapper configuration</a>
                    <div *ngIf="showDeveloperOptions">
                        <a (click)="this.router.navigateByUrl('/settings/developer-options')">Developer options</a>
                    </div>
                </div>

                <div *ngSwitchCase="'/analysis/summary'">
                    <h3>Configure</h3>
                    <a>Dashboard settings</a>
                    <a (click)="this.router.navigateByUrl('/settings/job-definition')">Job definitions</a>
                    <a (click)="this.router.navigateByUrl('/settings/mapper-config')">Mapper configuration</a>
                    <div *ngIf="showDeveloperOptions">
                        <a (click)="this.router.navigateByUrl('/settings/developer-options')">Developer options</a>
                    </div>
                </div>

                <div *ngSwitchDefault>
                    <h3>Configure</h3>
                    <a (click)="this.router.navigateByUrl('/settings/job-definition')">Job definitions</a>
                    <a (click)="this.router.navigateByUrl('/settings/mapper-config')">Mapper configuration</a>
                    <div *ngIf="showDeveloperOptions">
                        <a (click)="this.router.navigateByUrl('/settings/developer-options')">Developer options</a>
                    </div>
                </div>
            </div>
        </div>
    </shared-header>
    <router-outlet></router-outlet>
</div>

<footer>
    &copy; 2026 - Dunstan Thomas Holdings Ltd.
</footer>

<dialog-overlay></dialog-overlay>
<shared-error-overlay></shared-error-overlay>